import to from "await-to-js";
import { Manifest } from "../../android/components/Manifest";
import { runPermissionGroup } from "../../android/components/permissionGroupCreator";
import { createWindowConfCopy } from "../../android/win/WindowConf";
import { WebViewJs } from "../../android/WebViewJs";
import { env } from "../../confs/env";


function createCopy(callbackEventType:string, windowId:string){
    let windowConf = {
        htmlConf:{
            url:`${env.htmlOrigin}pages/accessibility-info-buttons/#/`,
            webViewJsParams:{
                javaToJsDataString:JSON.stringify({event:callbackEventType})
            }
        },windowId
    }
    return createWindowConfCopy(windowConf)
}

function openWindow(callbackEventType:string, windowId:string){
    let conf = createCopy(callbackEventType, windowId);
    return WebViewJs.instance.createWindow(JSON.stringify(conf))
}
export async function openHtmlShowA11yNodeInfoButton(callbackEventType:string, windowId:string){
    let [err, group] = await to(runPermissionGroup(Manifest.Permission.SYSTEM_ALERT_WINDOW,
        Manifest.Permission.BIND_ACCESSIBILITY_SERVICE))
    if(err){
        alert(err.toString())
        WebViewJs.instance.toast(err.toString())
        // showSimpleToast(err.toString())
        return;
    }
    return openWindow(callbackEventType, windowId);
}